/**
 * The main api service
 */
import http from '@util/http';
import {incubator} from '@api/req';

export async function queryBusinessIndepositTurn(params) {
  return http.post(incubator.INCU_INDEPOSIT_TURN, params);
}

export async function queryIncuBusinessRemind(params) {
  return http.get(incubator.INCU_BUSINESS_REMIND, params);
}

export async function queryIncuBusinessOverdue(params) {
  return http.get(incubator.INCU_BUSINESS_OVERDUE, params);
}

export async function queryIncuBusinessRemindOregistapp(params) {
  return http.get(incubator.INCU_BUSINESS_REMIND_OREGISTAPP, params);
}

export async function queryIncuBusinessOverdueOregistapp(params) {
  return http.get(incubator.INCU_BUSINESS_OVERDUE_OREGISTAPP, params);
}

export async function queryIncuBusinessSigning(params) {
  const url = params.customUuid ? incubator.CUSTOM_SIGNING : incubator.INCU_BUSINESS_SIGNING;
  return http.get(url, params);
}

export async function queryIncuBusinessArchving(params) {
  const url = params.customUuid ? incubator.CUSTOM_ARCHIVING : incubator.INCU_BUSINESS_ARCHIVING;
  return http.get(url, params);
}

export async function queryIncuBusinessArchved(params) {
  const url = params.customUuid ? incubator.CUSTOM_ARCHIVIED : incubator.INCU_BUSINESS_ARCHIVED;
  return http.get(url, params);
}

export async function queryIncuBusinessArchve(params) {
  return http.get(incubator.ARCHIVE_BUSINESS, params);
}



// WEBPACK FOOTER //
// ./src/api/incubator/business.js